module.exports = __webpack_public_path__ + "img/11.dd0884c0.jpg";